module.exports = __webpack_public_path__ + "static/assets/31d960a38257129b62ae854f5321c4ac.svg";